import React from 'react';
import { CompassIcon } from 'lucide-react';
import { systemAnswers } from '../data/content';
export function SystemSection() {
  return <section className="border-y border-night-line bg-night" data-id="element-240" data-mp="3gihnrhnozuqh">
      <div className="mx-auto max-w-content px-6 py-16 lg:py-24" data-id="element-241" data-mp="3bi3r0vrjk77r">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-242" data-mp="3bkpuokbba2kp">
          <div data-id="element-243" data-mp="36jk5gwgv0xfx">
            <CompassIcon className="h-9 w-9 text-gold-soft" aria-hidden="true" data-id="element-244" data-mp="36m68cist2ort" />
            <h2 className="mt-6 font-display text-3xl font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-245" data-mp="31m0ecvz2cq6k">
              El sistema GPS Bíblico
            </h2>
            <p className="mt-5 font-sans text-base leading-relaxed text-parchment/70" data-id="element-246" data-mp="2st6wqrw59epj">
              Una forma visual de ubicar cada libro dentro de la Historia de la Salvación.
              No es solo leer la Biblia: es saber siempre en qué punto del camino estás.
            </p>
          </div>

          <ol className="relative border-l border-night-line pl-8" data-id="element-247" data-mp="2dwfsa47m5ct2">
            {systemAnswers.map((item, index) => <li key={item.label} className="relative pb-10 last:pb-0" data-id="element-248" data-mp="13xwrt43gv4w6" data-mpi={index}>
                <span aria-hidden="true" className="absolute -left-[2.3rem] top-1 flex h-6 w-6 items-center justify-center rounded-full bg-gold-soft font-sans text-xs font-bold text-night" data-id="element-249" data-mp="18qpyhxihwnaw">
                  {index + 1}
                </span>
                <h3 className="font-display text-2xl font-semibold text-gold-soft" data-id="element-250" data-mp="1mr0rp77a2dz8">
                  {item.label}
                </h3>
                <p className="mt-1.5 font-sans text-base leading-relaxed text-parchment/70" data-id="element-251" data-mp="1rmps1cr4fywl">
                  {item.description}
                </p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}